import { Config } from "../config";

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function login(payload) {
  try {
    let routeName = "/auth";
    let headers = new Headers({
      "Accept": "application/json",
      "Content-Type": "application/json",
    });

    const response = await fetch(Config.apiUrl + routeName, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    return await response;
  } catch (error) {}
}

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
 export async function getProfile() {
  try {
    let routeName = "/profile";
    let headers = new Headers({
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + routeName, {
      method: "GET",
      headers
    });

    return await response;
  } catch (error) {}
}

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function refresh() {
  try {
    let routeName = "/refresh";
    let headers = new Headers({
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("refresh_token"),
    });

    const response = await fetch(Config.apiUrl + routeName, {
      method: "POST",
      headers,
      body: JSON.stringify({}),
    });

    return await response;
  } catch (error) {}
}
